import React from 'react';
import { useLeadsNurture } from './useLeadsNurture';
import { LeadsNurture } from './LeadsNurture';
import { T_LeadsNature } from '@sky-tv-group/shared';

interface Props {
  apiEndpoint: string;
  isSignedIn?: boolean;
}

export let LeadManager = ({ apiEndpoint, isSignedIn = false }: Props) => {
  const { bottomLeads, activePopup, dismissLead } = useLeadsNurture({
    apiEndpoint,
    isSignedIn,
  });

  return (
    <>
      {/* Bottom aligned leads (always visible, not dismissable) */}
      <div>
        {bottomLeads.map((lead: T_LeadsNature) => (
          <LeadsNurture key={lead.id} leadContent={lead} dismissAction={() => {}} />
        ))}
      </div>

      {/* Popup lead (timed and dismissable, only one at a time) */}
      {activePopup && (
        <LeadsNurture key={activePopup.id} leadContent={activePopup} dismissAction={() => dismissLead(activePopup)} />
      )}
    </>
  );
};
